import { useAdminSystem } from "../../../lib/api/admin.api";
import { formatBytes } from "../../../shared/helpers/format-date";

export function AdminSystemTab() {
  const { data: system, isLoading } = useAdminSystem();

  if (isLoading) return <p className="text-ink-muted text-sm">Chargement...</p>;
  if (!system) return <p className="text-ink-muted text-sm">Erreur de chargement</p>;

  const totalRecords = system.db.users + system.db.tasks + system.db.events + system.db.habits + system.db.images;

  return (
    <div className="flex flex-col gap-6">
      {/* Version */}
      <section>
        <h3 className="text-sm font-semibold text-ink mb-3">Application</h3>
        <div className="bg-surface-alt rounded-xl p-3 flex items-center gap-3">
          <span className="text-xs text-ink-muted">Version</span>
          <span className="text-sm font-bold text-accent">v{system.version}</span>
        </div>
      </section>

      {/* Base de données */}
      <section>
        <h3 className="text-sm font-semibold text-ink mb-3">Base de données</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {[
            { label: "Utilisateurs", value: system.db.users },
            { label: "Tâches", value: system.db.tasks },
            { label: "Événements", value: system.db.events },
            { label: "Habitudes", value: system.db.habits },
            { label: "Images", value: system.db.images },
            { label: "Total", value: totalRecords },
            { label: "Taille DB", value: system.db.sizeBytes ? formatBytes(system.db.sizeBytes) : "—" },
          ].map((item) => (
            <div key={item.label} className="bg-surface-alt rounded-xl p-3 flex flex-col gap-1">
              <span className="text-xl font-bold text-ink">{item.value}</span>
              <span className="text-xs text-ink-muted">{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Stockage */}
      <section>
        <h3 className="text-sm font-semibold text-ink mb-3">Stockage images</h3>
        <div className="bg-surface-alt rounded-xl p-3 mb-3">
          <span className="text-2xl font-bold text-ink">{formatBytes(system.storage.totalBytes)}</span>
          <span className="text-xs text-ink-muted ml-2">utilisés au total</span>
        </div>

        {system.storage.topUsers.length > 0 && (
          <div className="bg-surface-alt rounded-xl p-3">
            <span className="text-xs text-ink-muted block mb-2">Top utilisateurs par stockage</span>
            <div className="flex flex-col gap-2">
              {system.storage.topUsers.map((u, i) => (
                <div key={u.userId} className="flex items-center gap-2 text-xs">
                  <span className="text-ink-faint w-4 text-right">{i + 1}.</span>
                  <span className="text-ink flex-1 truncate">{u.name}</span>
                  <span className="text-ink-muted">{u.email}</span>
                  <span className="text-ink font-medium shrink-0">{formatBytes(u.bytes)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
